import { render, staticRenderFns } from "./ProviderRegister.vue?vue&type=template&id=ac6e76fa&scoped=true"
import script from "./ProviderRegister.vue?vue&type=script&lang=js"
export * from "./ProviderRegister.vue?vue&type=script&lang=js"
import style0 from "./ProviderRegister.vue?vue&type=style&index=0&id=ac6e76fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6e76fa",
  null
  
)

export default component.exports